module.exports = __webpack_public_path__ + "static/media/Xiaomi Mi Mix Alpha Back.d98c6185.png";